import { useRouter } from "next/router";
import qs from "qs";

import { config } from "shared/data";
import { sanitizedParametersByKeys } from "shared/lib/router";
import { getAbsoluteUrl, isValidUrl } from "shared/lib/utils";

export const SanitizedUrlKeys = ["char"];

export const useCanonicalUrl = (url?: string) => {
  const router = useRouter();
  const canonicalUrl = getAbsoluteUrl(url ?? router.asPath, config.general.canonicalBaseUrl);
  if (isValidUrl(canonicalUrl)) {
    const url = new URL(canonicalUrl);
    const { sanitizedQueryString } = sanitizedParametersByKeys(SanitizedUrlKeys, url.search);
    url.search = qs.stringify({ ...sanitizedQueryString });
    return {
      canonicalUrl: url.toString(),
    };
  }

  return {
    canonicalUrl,
  };
};
